import {
    type NodeCfg,
    type NodeSocketKindMap,
} from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { RequiredSockets, UiNodeSpec } from './UiNodeSpec';

export const timestampUiNodeSpec: UiNodeSpec<'timestamp'> = {
    kindLabel: 'Timestamp',
    nodeCategory: 'timeAndDate',
    validator: _node => {
        return true;
    },
    controls: _getNodeCfg => {
        const ret: ReturnType<UiNodeSpec<'timestamp'>['controls']> = {};
        return ret;
    },
    cfg: () => {
        const timestampNodeCfg: NodeCfg<'timestamp'> = {
            id: getUID(),
            kind: 'timestamp',
            controlValues: {},
        };
        return timestampNodeCfg;
    },
    inputs: _nodeCfg => {
        const inputs: ReturnType<UiNodeSpec<'timestamp'>['inputs']> = {
            trigger: { socket: 'event', label: 'Trigger' },
        };
        return inputs;
    },
    outputs: () => {
        const ret: ReturnType<UiNodeSpec<'timestamp'>['outputs']> = {
            next: { socket: 'event', label: 'next' },
            epoch: { socket: 'number', label: 'Unix Epoch' },
        };
        return ret;
    },
    requiredSockets: node => {
        const ret: ReturnType<RequiredSockets<typeof node.kind, NodeSocketKindMap[typeof node.kind]>> = {
            required: [ 'epoch' ],
            conditionallyRequired: [],
        };
        return ret;
    },
};
